import { useMap, useMapsLibrary } from "@vis.gl/react-google-maps";
import { useEffect, useState } from "react";

export const Directions = ({
  printPath,
  enable,
  directions,
  setDirections,
}: {
  directions: any;
  setDirections: (val: any) => void;
  printPath: any[];
  enable: boolean;
}) => {
  const map = useMap();
  const routesLibrary = useMapsLibrary("routes");

  const [directionService, setDirectionService] =
    useState<google.maps.DirectionsService>();

  const [directionRenderer, setDirectionRenderer] =
    useState<google.maps.DirectionsRenderer>();

  //   const [direction, setDirection] =
  //     useState<google.maps.DirectionsResult | null>(null);

  useEffect(() => {
    if (!routesLibrary || !map) return;
    setDirectionService(new routesLibrary.DirectionsService());
    setDirectionRenderer(new routesLibrary.DirectionsRenderer({ map }));
  }, [routesLibrary, map]);

  useEffect(() => {
    if (!directions || !directionRenderer || !enable) return;

    directionRenderer.setDirections(directions);
  }, [directions, directionRenderer, enable]);

  useEffect(() => {
    if (!directionService || !directionRenderer) return;

    if (enable) {
      const origin = printPath[0];
      const destination = printPath[printPath.length - 1];
      const waypoints = printPath
        .slice(1, -1)
        .map((location: any) => ({ location, stopover: false }));

      directionService
        .route({
          origin,
          destination,
          waypoints,
          optimizeWaypoints: true,
          travelMode: google.maps.TravelMode.DRIVING,
        })
        .then((response) => {
          setDirections(response);
          console.log("directions: ", response);
        });
    }
  }, [directionRenderer, directionService, enable, printPath]);

  useEffect(() => {
    if (directionRenderer) {
      if (enable) {
        directionRenderer.setMap(map);
      } else {
        directionRenderer.setMap(null);
      }
    }

    return () => {
      directionRenderer?.setMap(null);
    };
  }, [directionRenderer, enable, map]);

  return null;
};
